<template>
	<section>
		<ButtonBack />
		<h1>Datenschutzverordnung</h1>
		<TheBox>
			<h2>1. Einleitung </h2>
			<p>
				Der Verein Gesellschaft zur Selbstkontrolle der Werbewirtschaft (kurz: Österreichischer Werberat) nimmt den Schutz Ihrer persönlichen Daten
				sehr ernst und hält sich strikt an die Regeln der Datenschutz-Grundverordnung (DSGVO) und des österreichischen Datenschutzgesetzes (DSG). In
				dieser Datenschutzverordnung informieren wir Sie darüber, welche personenbezogenen Daten wir erheben, zu welchem Zweck wir diese Daten
				verwenden und wie wir Ihre Daten schützen.
			</p>

			<h2>2. Verantwortlicher </h2>

			<p>Verantwortlicher im Sinne der DSGVO und des DSG ist: </p>
			<p>
				Verein Gesellschaft zur Selbstkontrolle der Werbewirtschaft (Österreichischer Werberat) <br />
				Wiedner Hauptstraße 57 / III, 1040 Wien <br />
				Tel: <a href="tel:05909003577" title="Werberat anrufen" class="link" target="_blank">+43 (0) 5 90 900 - 3577</a><br />
				E-Mail: <a href="mailto:office@werberat.at" title="E-Mail an Werberat schicken" class="link" target="_blank">office@werberat.at</a> <br />
				Internet: <a href="https://www.werberat.at/" title="werberat.at" class="link" target="_blank">www.werberat.at</a> <br />
				Präsident: Michael Straberger <br />
				Geschäftsführerin: Mag.a Andrea Stoidl
			</p>

			<h2>3. Erhebung und Verarbeitung personenbezogener Daten </h2>

			<p>Wir erheben und verarbeiten folgende personenbezogene Daten:</p>
			<ul>
				<li>Vor- und Nachname</li>
				<li>Anrede</li>
				<li>Firmenname</li>
				<li>Telefonnummer</li>
				<li>E-Mail-Adresse</li>
				<li>Weitere gesammelte Daten, welche direkt oder indirekt die entsprechende Person identifizieren könnten.</li>
			</ul>

			<h2>4. Zweck der Datenverarbeitung</h2>
			<p
				>Die Erhebung und Verarbeitung der personenbezogenen Daten erfolgen ausschließlich zu dem Zweck, Ihre Beschwerde zu bearbeiten und ggf. zur
				Verteidigung von Rechtsansprüchen. Ihre personenbezogenen Daten können ausschließlich von den MitarbeiterInnen des Österreichischen Werberates
				eingesehen werden und werden nicht an Dritte weitergegeben.</p
			>

			<h2>5. Rechtsgrundlage der Datenverarbeitung</h2>
			<p
				>Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO sowie zur Erfüllung
				eines Vertrages bzw. zur Durchführung vorvertraglicher Maßnahmen gemäß Art. 6 Abs. 1 lit. b DSGVO. Die Speicherung zur Verteidigung von
				Rechtsansprüchen erfolgt auf Grundlage berechtigter Interessen gemäß Art. 6 Abs. 1 lit. f DSGVO.</p
			>

			<h2>6. Dauer der Speicherung</h2>
			<p
				>Ihre personenbezogenen Daten werden für die Dauer der Bearbeitung Ihrer Beschwerde und für 6 Monate nach Abschluss des Beschwerdeverfahrens
				gespeichert. Dies erfolgt zur etwaigen Verteidigung von Rechtsansprüchen. Nach Ablauf dieser Frist wird Ihre Beschwerde anonymisiert und die
				personenbezogenen Daten gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</p
			>

			<h2>7. Ihre Rechte</h2>
			<p
				>Sie haben das Recht, jederzeit Auskunft über die von uns gespeicherten personenbezogenen Daten zu erhalten. Darüber hinaus haben Sie das
				Recht auf Berichtigung, Löschung, Einschränkung der Verarbeitung sowie auf Datenübertragbarkeit. Sie können der Verarbeitung Ihrer
				personenbezogenen Daten widersprechen und eine erteilte Einwilligung jederzeit widerrufen. Hierzu können Sie sich an die oben angegebenen
				Kontaktdaten wenden.</p
			>
			<p
				>Sollten Sie der Ansicht sein, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die DSGVO verstößt, haben Sie das Recht, sich bei der
				zuständigen Aufsichtsbehörde zu beschweren. In Österreich ist dies die Datenschutzbehörde.</p
			>

			<h2>8. Datensicherheit</h2>
			<p
				>Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen,
				teilweisen oder vollständigen Verlust, Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen.</p
			>

			<h2>9. Cookies und Erfassung allgemeiner Daten</h2>
			<p
				>Unsere Internetseiten verwenden Cookies, um die Benutzererfahrung zu verbessern. Cookies sind Textdateien, die über einen Internetbrowser auf
				einem Computersystem abgelegt und gespeichert werden. Die betroffene Person kann die Setzung von Cookies jederzeit durch eine entsprechende
				Einstellung des genutzten Internetbrowsers verhindern und damit der Setzung von Cookies dauerhaft widersprechen.</p
			>
			<p
				>Bei jedem Aufruf unserer Internetseite erfassen wir automatisch eine Reihe von allgemeinen Daten und Informationen, die in den Logfiles des
				Servers gespeichert werden. Diese umfassen u.a. den Browsertyp und die Version, das Betriebssystem, die Referrer-URL, die IP-Adresse, den
				Internet-Service-Provider und das Datum und die Uhrzeit des Zugriffs. Diese anonym erhobenen Daten und Informationen werden statistisch
				ausgewertet, um den Datenschutz und die Datensicherheit zu erhöhen und ein optimales Schutzniveau für die verarbeiteten personenbezogenen
				Daten sicherzustellen.</p
			>

			<h2>10. Kontaktmöglichkeiten</h2>
			<p
				>Wenn Sie per E-Mail oder über ein Kontaktformular mit uns in Verbindung treten, werden die von Ihnen übermittelten personenbezogenen Daten
				automatisch gespeichert. Diese auf freiwilliger Basis übermittelten Daten werden für die Zwecke der Bearbeitung oder der Kontaktaufnahme
				gespeichert. Es erfolgt keine Weitergabe dieser Daten an Dritte.</p
			>

			<h2>11. Änderungen der Datenschutzverordnung</h2>
			<p
				>Wir behalten uns das Recht vor, diese Datenschutzverordnung bei Bedarf zu ändern, um sie an geänderte Rechtslagen oder bei Änderungen des
				Dienstes sowie der Datenverarbeitung anzupassen. Die aktuelle Version der Datenschutzverordnung kann jederzeit auf unserer Website abgerufen
				werden.</p
			>

			<h2>12. Kontakt</h2>
			<p
				>Für Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, Berichtigung, Sperrung oder Löschung von
				Daten sowie Widerruf erteilter Einwilligungen wenden Sie sich bitte an:</p
			>
			<p>
				Verein Gesellschaft zur Selbstkontrolle der Werbewirtschaft (Österreichischer Werberat)<br />
				Wiedner Hauptstraße 57 / III, 1040 Wien <br />
				Tel: <a href="tel:05909003577" title="Werberat anrufen" class="link" target="_blank">+43 (0) 5 90 900 - 3577</a><br />
				E-Mail: <a href="mailto:office@werberat.at" title="E-Mail an Werberat schicken" class="link" target="_blank">office@werberat.at</a> <br />
				Internet: <a href="https://www.werberat.at/" title="werberat.at" class="link" target="_blank">www.werberat.at</a> <br />
				Präsident: Michael Straberger <br />
				Geschäftsführerin: Mag.a Andrea Stoidl<br />
			</p>
		</TheBox>
	</section>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import ButtonBack from '../components/buttons/ButtonBack.vue';
import TheBox from '../components/TheBox.vue';

export default defineComponent({
	name: 'Datenschutz',
	data() {
		return {};
	},
	components: {
		ButtonBack,
		TheBox,
	},
	computed: {},
	methods: {},
	mounted() {},
});
</script>

<style lang="scss">
@use '../scss/vars.scss' as *;

#datenschutz {
	.link {
		margin-bottom: 0;
	}

	h2 {
		margin-top: 2.5rem;
		&:first-child {
			margin-top: 0;
		}
	}

	section {
		margin-bottom: 3rem;
	}

	ul {
		padding-left: 1rem;
		margin-top: 0;
		li {
			list-style-type: none;
			&::before {
				content: '-';
				padding-right: 1rem;
			}
		}
	}
}

/* mobile styles */
@media screen and (max-width: $mobile_maxwidth) {
	#datenschutz {
		h1 {
			font-size: 1.8rem;
		}
	}
}
</style>
